import { render, staticRenderFns } from "./SalesRankingCard.vue?vue&type=template&id=11efb2f4&scoped=true"
import script from "./SalesRankingCard.vue?vue&type=script&lang=js"
export * from "./SalesRankingCard.vue?vue&type=script&lang=js"
import style0 from "./SalesRankingCard.vue?vue&type=style&index=0&id=11efb2f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11efb2f4",
  null
  
)

export default component.exports